import React, { useState, useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import "./Tutorial.css";

const tutorialImages = ["/tutorial1.png", "/tutorial2.png", "/tutorial3.png"];

const Tutorial = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openModal = useCallback((index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const showNextImage = useCallback((e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setCurrentImageIndex((prev) => (prev + 1) % tutorialImages.length);
  }, []);

  const showPrevImage = useCallback((e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setCurrentImageIndex(
      (prev) => (prev - 1 + tutorialImages.length) % tutorialImages.length
    );
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModalOpen) return;
      if (e.key === "ArrowRight") showNextImage();
      else if (e.key === "ArrowLeft") showPrevImage();
      else if (e.key === "Escape") closeModal();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen, showNextImage, showPrevImage, closeModal]);

  useEffect(() => {
    if (isModalOpen) {
      // Get the original body padding
      const originalPaddingRight = document.body.style.paddingRight;

      // Calculate scrollbar width
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      // Apply styles to prevent scrolling and layout shift
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      // Cleanup function to restore original styles
      return () => {
        document.body.style.overflow = "auto";
        document.body.style.paddingRight = originalPaddingRight;
      };
    }
  }, [isModalOpen]);

  const modalRoot =
    typeof document !== "undefined" && document.getElementById("modal-root");

  return (
    <section id="tutorial" className="tutorial animate">
      <h2>How ClevSheets AI Works in Google Sheets</h2>{" "}
      <div className="tutorial-steps">
        {tutorialImages.map((src, index) => (
          <div
            key={src}
            className="tutorial-step"
            onClick={() => openModal(index)}
          >
            <img src={src} alt={`Tutorial step ${index + 1}`} />
          </div>
        ))}
      </div>
      {isModalOpen &&
        modalRoot &&
        ReactDOM.createPortal(
          <div className="modal-overlay" onClick={closeModal}>
            <button className="close-button" onClick={closeModal}>
              &times;
            </button>
            <button className="nav-arrow prev" onClick={showPrevImage}>
              &#10094;
            </button>
            <img
              src={tutorialImages[currentImageIndex]}
              alt={`Enlarged tutorial step ${currentImageIndex + 1}`}
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
            />
            <button className="nav-arrow next" onClick={showNextImage}>
              &#10095;
            </button>
          </div>,
          modalRoot
        )}
    </section>
  );
};

export default Tutorial;
